__turbopack_context__.v({
  "className": "inter_5972bc34-module__OU16Qa__className",
});
